if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
        constructor() {
          super();
          this.input = this.querySelector('.quantity__input');
          this.currentVariant = this.querySelector('.product-variant-id');
          this.variantSelects = this.querySelector('variant-radios')
          this.submitButton = this.querySelector('[type="submit"]');
        }

        cartUpdateUnsubscriber = undefined;
        variantChangeUnsubscriber = undefined;

        connectedCallback() {
          if (!this.input) return;
          this.quantityForm = this.querySelector('.product-form__quantity');
          if (!this.quantityForm) return;
          this.setQuantityBoundries();
          if (!this.dataset.originalSection) {
            this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
          }
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
            if (event.data.sectionId !== sectionId) return;
            this.updateQuantityRules(event.data.sectionId, event.data.html);
            this.setQuantityBoundries();
          });
        }

        disconnectedCallback() {
          if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
          }
          if (this.variantChangeUnsubscriber) {
            this.variantChangeUnsubscriber();
          }
        }

        setQuantityBoundries() {
          const data = {
            cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
            min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
            max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
            step: this.input.step ? parseInt(this.input.step) : 1
          }

          let min = data.min;
          const max = data.max === null ? data.max : data.max - data.cartQuantity;
          if (max !== null) min = Math.min(min, max);
          if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

          this.input.min = min;
          this.input.max = max;
          this.input.value = min;
          publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
        }

        fetchQuantityRules() {
          if (!this.currentVariant || !this.currentVariant.value) return;
          //this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
          fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`).then((response) => {
            return response.text()
          })
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                this.updateQuantityRules(this.dataset.section, html);
                this.setQuantityBoundries();
              })
              .catch(e => {
                console.error(e);
              })
              .finally(() => {
               // this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
              });
        }

        updateQuantityRules(sectionId, html) {
          const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
          const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
          for (let selector of selectors) {
            const current = this.quantityForm.querySelector(selector);
            const updated = quantityFormUpdated.querySelector(selector);
            if (!current || !updated) continue;
            if (selector === '.quantity__input') {
              const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
              for (let attribute of attributes) {
                const valueUpdated = updated.getAttribute(attribute);
                if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
              }
            } else {
              current.innerHTML = updated.innerHTML;
            }
          }
        }
      }
  )};


$( document ).ready(function() {

  var _toggleDescription = $('.p_description-wrap button');

  if(_toggleDescription.length) {
    _toggleDescription.each(function(){
      var _button = $(this);
      _button.on('click', function(){
        if(!_button.hasClass('active')) {
          _toggleDescription.removeClass('active');
          $(this).addClass('active');
        }
      });
    })
  }

  var _toggleSize = $('.options-product.qty_size');
  if(_toggleSize.length) {
    var _sizeLabel = _toggleSize.find('.size-label-action');
    _sizeLabel.on('click', function(){
      _toggleSize.toggleClass('open');
    });
    $(document).on('click', function (event) {
      if (!_sizeLabel.is(event.target)
          && _sizeLabel.has(event.target).length === 0) {
        _toggleSize.removeClass('open');
      }
    });
  }

  var _option = $('.field-options-color .item-option');
  if(_option.length) {
    _option.each(function(){
      var _label = $('.field-options-color .field-color .value');
      var _input = $(this).find('input[type="radio"]');
      _input.on('click', function(){
        _label.text($(this).val());
      });
    });
  }

  var _optionSize = $('.qty_size .field-options .item-option');
  if(_optionSize.length) {
    _optionSize.each(function(){
      var _label = $('.qty_size .size-label-action .value');
      var _input = $(this).find('input[type="radio"]');
      _input.on('click', function(){
        _label.text($(this).val());
      });
    });
  }

  var _height = $('.grid__item.product__media-wrapper');
  var _updateHeight = function () {
    if(_height.length) {
      setTimeout((f)=>{
        var _heightMedia = _height.height();
        $('.product.bb--pdp').css('min-height', _heightMedia);
      },1000)

    }
  }
  $(window).resize(function () {
    _updateHeight();
  });

  var _nb = 0;

  var _sizeGuide = function () {
    var __size_guide = $('#size_sweetecom');
    if(__size_guide.length) {
      var _sizeRadios = $('.size-guide-radios');
      if(_sizeRadios.length) {
        __size_guide.find('.size_button').appendTo(_sizeRadios);
      }
    }
  }

  _updateHeight();
  setTimeout(_sizeGuide, 2500);

  var __scrollReviews = function () {
    var _el = $('product-info .spr-starrating.spr-summary-starrating');
    if(_el.length) {
      _el.on('click', function(){
        var el= document.querySelector('#shopify-product-reviews[data-id]');
        el && el.scrollIntoView();return false;
      });
    }
  }

  __scrollReviews();
});
